import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTrendingDown, FiClock, FiAlertCircle } = FiIcons;

const LiveInventoryCounter = () => {
  const [viewersCount, setViewersCount] = useState(23);
  const [recentActivity, setRecentActivity] = useState([]);

  // Simulate live activity
  useEffect(() => {
    const activities = [
      "Someone in Los Angeles just scheduled a test drive for Q5 Premium Plus",
      "A customer in Beverly Hills is currently viewing this Q7",
      "Someone just submitted a financing application for A4 S-Line",
      "2 people are currently looking at this vehicle",
      "A customer in Santa Monica just requested a quote",
      "Someone in Pasadena is comparing this with 2 other vehicles"
    ];

    const updateActivity = () => {
      const randomActivity = activities[Math.floor(Math.random() * activities.length)];
      setRecentActivity(prev => [
        { id: Date.now(), text: randomActivity, time: new Date() },
        ...prev.slice(0, 2)
      ]);
    };

    const updateViewers = () => {
      setViewersCount(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // -2 to +2
        return Math.max(15, Math.min(45, prev + change));
      });
    };

    // Initial activity
    updateActivity();
    
    // Set intervals
    const activityInterval = setInterval(updateActivity, 8000);
    const viewersInterval = setInterval(updateViewers, 12000);

    return () => {
      clearInterval(activityInterval);
      clearInterval(viewersInterval);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gray-800 rounded-lg p-4 border border-gray-700"
    >
      <div className="space-y-4">
        {/* Live Viewers */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-white text-sm font-medium">
              {viewersCount} people viewing inventory now
            </span>
          </div>
          <SafeIcon icon={FiTrendingDown} className="w-4 h-4 text-audi-red" />
        </div>

        {/* Urgency Indicators */}
        <div className="bg-red-900/20 border border-red-800 rounded-lg p-3">
          <div className="flex items-center space-x-2 mb-2">
            <SafeIcon icon={FiAlertCircle} className="w-4 h-4 text-red-400" />
            <span className="text-red-400 text-sm font-medium">Limited Inventory Alert</span>
          </div>
          <p className="text-gray-300 text-sm">
            Only 3 Q5 Premium Plus models left in this color. High demand expected this weekend.
          </p>
        </div>

        {/* Recent Activity Feed */}
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiClock} className="w-4 h-4 text-gray-400" />
            <span className="text-gray-400 text-sm">Recent Activity</span>
          </div>
          
          {recentActivity.map((activity) => (
            <motion.div
              key={activity.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-gray-300 text-xs bg-gray-700/50 rounded p-2"
            >
              {activity.text}
              <span className="text-gray-500 ml-2">
                {new Date(activity.time).toLocaleTimeString([], { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Action Prompt */}
        <div className="bg-audi-red/10 border border-audi-red/30 rounded-lg p-3">
          <p className="text-audi-red text-sm font-medium">
            🔥 Act fast! Submit your information now to secure priority access and exclusive pricing.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default LiveInventoryCounter;